import { ApiProperty } from '@nestjs/swagger';
import { IsString, MaxLength, MinLength } from 'class-validator';

/** Body de POST /middleware-sifen/evento/liberar/:tipoDocumento/:id. */
export class LiberarEventoDto {
  @ApiProperty({ description: 'Por qué se libera el evento (queda en el documento y en auditoría)' })
  @IsString()
  @MinLength(5)
  @MaxLength(300)
  motivo: string;
}
